import React from 'react'
import Content from '../Realizzazione/Content'
import PhotoFrame from './PhotoFrame'
import { styles } from '../Realizzazione'
import { makeStyles } from '@material-ui/core/styles'
import VisibilitySensor from '../VisibilitySensor'
import { DettagliPageConfig } from '../../configuration'
import AssignId from '../AssignId'

const useStyles = makeStyles(styles)

export default function Dettagli() {
    const classes = useStyles()
    return (
        <div className={classes.wrap} >
            <div className={classes.root} >
                <AssignId
                    absolute
                    y='-20px'
                    yMobile='-30px'
                    id={DettagliPageConfig.slug}
                />
                <Content
                    primaryText={DettagliPageConfig.content.primary}
                    secondaryText={DettagliPageConfig.content.secondary}
                />
                <VisibilitySensor index={6} />
                <PhotoFrame />
            </div>
        </div>
    )
}